import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import ReactPixel from 'react-facebook-pixel'
import * as insTokenDuck from '../Onboarding/insTokenDuck'
import { checkSSOLogin } from './loginDuck'
import selectors from '../../../store/shared/selectors'
import AuthCard from '../../../components/ui/cards/AuthCard'
import NavBar from '../../../components/ui/navigation/NavBar'
import notificationsUtils from '../../../utils/notifications/notificationsUtils'
import LoginForm from './components/LoginForm'
import LoginWithEmailLinkForm from './components/LoginWithEmailLinkForm'
import constants from '../../../utils/constants/application';

class UnauthenticatedLoginIndex extends Component {
  static propTypes = {
    checkSSOLogin: PropTypes.func,
    history: PropTypes.any.isRequired,
    lessThanMedium: PropTypes.bool.isRequired,
    queryParams: PropTypes.any.isRequired,
    universityData: PropTypes.object,
    validateInsToken: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      emailLogin: true, // use for email and password login
      emailLinkLogin: true, // use for email link login
      shortName: null,
      accessLinkRequested: false,
      showSingupFormForEmailLink: false,
      universityActive: true,
      universityLogo: null,
      universityName: null,
    }
  }

  componentWillMount() {
    const shortName = window.location.hostname.split('.')[0]
    if (shortName !== 'app') {
      this.props.checkSSOLogin({ shortName }).then(data => {
        if (data) {
          if (!data.universityActive && !constants.isDevelopment) {
            this.setState({ universityActive: false })
            notificationsUtils.showErrorNotification('Subscription expired.')
          }

          if (data.ssoAvailable) this.setState({ emailLogin: false, shortName })
          else
            this.setState({
              universityLogo: data.universityLogo,
              universityName: data.universityName,
            })

          if (data.disableEmailLinkLogin) this.setState({ emailLinkLogin: false })
        }
      })
    }
  }

  componentDidMount() {
    const {
      queryParams: { insToken, error, showSingupFormForEmailLink },
    } = this.props
    if (insToken)
      this.props
        .validateInsToken({ insToken })
        .then(() => {})
        .catch(() => {})
    if (error) notificationsUtils.showErrorNotification(error)
    if (showSingupFormForEmailLink && !this.state.showSingupFormForEmailLink)
      this.setState({ showSingupFormForEmailLink: true })

    ReactPixel.pageView()
    ReactPixel.track('ViewContent')
  }

  render() {
    const { lessThanMedium, queryParams, history, universityData } = this.props
    const {
      accessLinkRequested,
      emailLogin,
      emailLinkLogin,
      shortName,
      showSingupFormForEmailLink,
      universityActive,
      universityLogo,
      universityName,
    } = this.state

    // TODO - do this a different way, quick patch for UGA
    const ssoButtonText =
      shortName === 'uga'
        ? 'University of Georgia MyID Login'
        : `${universityData && universityData.universityName} Sign On`

    return (
      <div>
        <NavBar noActions={!emailLogin} />
        <div className="container">
          <div className="max-800">
            {universityActive ? (
              <AuthCard
                delay={0.5}
                title="Welcome Back!"
              >
                <div>
                  {emailLogin ? (
                    <div style={{ marginBottom: 50, marginTop: 25 }}>
                      {universityLogo && (
                        <img
                          src={universityLogo}
                          alt={`${universityName} Logo`}
                          style={{
                            marginBottom: 20,
                            maxWidth: lessThanMedium ? 200 : 400,
                            maxHeight: 200,
                          }}
                        />
                      )}
                      {queryParams.showImpersonation ? (
                        <LoginForm
                          showImpersonation={queryParams.showImpersonation}
                          setAccessLinkRequested={() =>
                            this.setState({ accessLinkRequested: true })
                          }
                        />
                      ) : (
                        <div className="max-400">
                          {accessLinkRequested ? (
                            <div className={`col-12 ${lessThanMedium ? 'pt-0' : 'pt-3'}`}>
                              <i
                                className="fas fa-check-circle"
                                style={{
                                  color: '#30bc9d',
                                  fontSize: 60,
                                  marginBottom: 10,
                                }}
                              />
                              <h4 style={{ fontSize: 18 }}>
                                Please check your email for access link!
                              </h4>
                            </div>
                          ) : (
                            <LoginWithEmailLinkForm
                              setAccessLinkRequested={() =>
                                this.setState({ accessLinkRequested: true })
                              }
                              setShowSingupFormForEmailLink={() =>
                                this.setState({
                                  showSingupFormForEmailLink: true,
                                })
                              }
                              showSingupFormForEmailLink={showSingupFormForEmailLink}
                            />
                          )}
                        </div>
                      )}
                      <div style={{ margin: 20 }} />
                      <span>
                        {' '}
                        Don't have an account?
                        <Link
                          to={{
                            pathname: '/signup',
                            search: history.location.search,
                          }}
                        >
                          {`   Sign up Now`}
                        </Link>
                      </span>
                    </div>
                  ) : (
                    <div style={{ marginBottom: 50, marginTop: 25 }}>
                      <img
                        src={universityData && universityData.universityLogo}
                        alt={`${universityData && universityData.universityName} Logo`}
                        style={{
                          marginBottom: 20,
                          maxWidth: lessThanMedium ? 200 : 400,
                          maxHeight: 200,
                        }}
                      />
                      <div>
                        <h6> Sign in to Steppingblocks </h6>
                        <a
                          className="btn btn-success"
                          // href={`${process.env.REACT_APP_API_HOST}${ACCOUNTS_ENDPOINTS.login}/${shortName}`}
                          href={universityData.loginUrl}
                          style={
                            lessThanMedium
                              ? { maxWidth: '100%', fontSize: 14 }
                              : {
                                  fontSize: 18,
                                  padding: '20px 30px',
                                  maxWidth: '100%',
                                }
                          }
                        >
                          {ssoButtonText}
                        </a>
                      </div>
                      {emailLinkLogin && (
                        <div>
                          <hr className="hr-text" data-content="OR" />
                          <div className="max-400">
                            {accessLinkRequested ? (
                              <div className={`col-12 ${lessThanMedium ? 'pt-0' : 'pt-3'}`}>
                                <i
                                  className="fas fa-check-circle"
                                  style={{
                                    color: '#30bc9d',
                                    fontSize: 60,
                                    marginBottom: 10,
                                  }}
                                />
                                <h4 style={{ fontSize: 18 }}>
                                  Please check your email for access link!
                                </h4>
                              </div>
                            ) : (
                              <LoginWithEmailLinkForm
                                setAccessLinkRequested={() =>
                                  this.setState({ accessLinkRequested: true })
                                }
                                setShowSingupFormForEmailLink={() =>
                                  this.setState({
                                    showSingupFormForEmailLink: true,
                                  })
                                }
                                showSingupFormForEmailLink={showSingupFormForEmailLink}
                              />
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </AuthCard>
            ) : (
              <AuthCard
                delay={0.5}
                title="Your institution is no longer offering Digital Career Counselor."
                subtitle="Follow the link below to enroll in an individual subscription."
              >
                <div style={{ marginBottom: 50, marginTop: 25, padding: 5 }}>
                  <a
                    href="https://app.steppingblocks.com/signup"
                    className="btn btn-success btn-sm"
                  >
                    Sign Up
                  </a>
                </div>
              </AuthCard>
            )}
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  lessThanMedium: selectors.isLessThanMedium(state),
  queryParams: selectors.getQueryStringSimply(state),
  universityData: state.login.universityData,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      checkSSOLogin,
      validateInsToken: insTokenDuck.performValidateInsToken,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(UnauthenticatedLoginIndex)



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/Login/UnauthenticatedLoginIndex.js